import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteAthleteAppointment from 'hooks/athleteAppointment/useDeleteAthleteAppointment';
import notificationHandler from 'utils/notifications';

interface IModalAthleteAppointmentDelete {
  opened: boolean;
  handleClose: () => void;
  athleteAppointmentId?: string;
  handleCloseDrawer: () => void;
  athleteAppointmentsLength: number;
}

const ModalAthleteAppointmentDelete = ({
  opened,
  athleteAppointmentId,
  handleClose,
  handleCloseDrawer,
  athleteAppointmentsLength,
}: IModalAthleteAppointmentDelete): JSX.Element => {
  const deleteAthleteAppointment = useDeleteAthleteAppointment();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (athleteAppointmentId) {
      deleteAthleteAppointment.mutate(athleteAppointmentId, {
        onSuccess: () => {
          if (athleteAppointmentsLength <= 1) {
            handleCloseDrawer();
          }
          successNotification('Athlete reservation delete success', `Reservation successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Athlete reservation delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete reservation</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete this reservation?`}</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={deleteAthleteAppointment.isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalAthleteAppointmentDelete;
